/* eslint-disable import/no-unresolved */
import {defineAsyncComponent} from 'vue';

/** 儿童隐私政策 版本清单与懒加载映射（同文件维护） */

const CHILD_POLICY_MANIFEST = [
    {
        id: '2026-07-20',
        title: '2026年7月修订版',
        subtitle: '最近更新：2026年7月20日（生效日期：2026年7月25日）',
        isDefault: true,
    },
    {
        id: '2026-05-07',
        title: '2026年5月修订版',
        subtitle: '最近更新：2026年5月7日（生效日期：2026年5月14日）',
        isDefault: false,
    },
    {
        id: '2026-02-26',
        title: '2026年2月修订版',
        subtitle: '最近更新：2026年2月26日（生效日期：2026年3月5日）',
        isDefault: false,
    },
    {
        id: '2025-11-24',
        title: '2025年11月修订版',
        subtitle: '最近更新：2025年11月24日（生效日期：2025年12月1日）',
        isDefault: false,
    },
    {
        id: '2025-04-22',
        title: '2025年4月修订版',
        subtitle: '最近更新：2025年4月22日（生效日期：2025年4月29日）',
        isDefault: false,
    },
];

const CHILD_POLICY_LOADERS = {
    '2026-07-20': () => import(/* webpackChunkName: "policy-child-202607" */ './versions/ChildPolicy20260720.vue'),
    '2026-05-07': () => import(/* webpackChunkName: "policy-child-202605" */ './versions/ChildPolicy20260507.vue'),
    '2026-02-26': () => import(/* webpackChunkName: "policy-child-202602" */ './versions/ChildPolicy20260226.vue'),
    '2025-11-24': () => import(/* webpackChunkName: "policy-child-202511" */ './versions/ChildPolicy20251124.vue'),
    '2025-04-22': () => import(/* webpackChunkName: "policy-child-202504" */ './versions/ChildPolicy20250422.vue'),
};

/** @type {Array<{id: string, title: string, subtitle: string, isDefault: boolean, component: object}>} */
// 每个版本在模块加载时只包装一次，保证 component 引用稳定 ——
// 若在 computed 里现包装，切走再切回会生成新组件对象，
// 导致 <keep-alive> 缓存永远命中不了且不断堆积。
export const POLICY_CHILD_VERSIONS = CHILD_POLICY_MANIFEST.map(row => ({
    ...row,
    component: defineAsyncComponent(CHILD_POLICY_LOADERS[row.id]),
}));

/** 解析 URL query.v 为有效版本 id，非法或缺省时回退到默认版本 */
export function resolveChildPolicyVersionId(queryV) {
    if (queryV && POLICY_CHILD_VERSIONS.some(x => x.id === queryV)) {
        return queryV;
    }
    const def = POLICY_CHILD_VERSIONS.find(x => x.isDefault);
    return def ? def.id : POLICY_CHILD_VERSIONS[0].id;
}
